import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M18.82 9.57c0 .19-.07.38-.22.53-.29.29-.77.29-1.06 0L12 4.56 6.46 10.1c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l6.07-6.07c.29-.29.77-.29 1.06 0l6.07 6.07c.15.15.22.34.22.53" }),
      _createElementVNode("path", { d: "M12.75 3.67V20.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.67c0-.41.34-.75.75-.75s.75.34.75.75" })
    ], -1)
  ]))]))
}
export default { render: render }